// Note : le backen utilise uniquemement ProgramVisibility
export enum BoxProgramVisibility {
  MEMBERS = "MEMBERS",
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE",
}

export enum BoxPopUp {
  TEMPLATE = "TEMPLATE",
  PROGRAM = "¨PROGRAM",
}
